import React from 'react';
import styled from 'styled-components';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { BarLoader } from 'react-spinners';
import { useSearchParams } from 'react-router-dom';
import AdblockDetector from 'SharedComponents/adblock-detector';
import styles from './index.css';

const TransactionLoadingWrapper = styled.div`${styles}`;

const TransactionLoading = () => {
  const [searchParams] = useSearchParams();
  const merchantName = searchParams.get('merchant_name');
  const retailStoreImageUrl = searchParams.get('retail_store_logo_url');
  const rate = searchParams.get('rate');

  return (
    <TransactionLoadingWrapper>
        <Helmet>
          <title>Taking you to {merchantName}</title>
          <meta name="description" content="Preparing to launch" />
        </Helmet>
      <div className="container">
        <div className="shopping-notification">
          <AdblockDetector />
        </div>
        <img src={retailStoreImageUrl} alt={merchantName}></img>
        <h1>Taking you to {merchantName}</h1>
        {/* <p>{merchantName} will {rate}</p> */}
        <p>Please wait while we take you to {merchantName}</p>
        <BarLoader
          sizeUnit={"px"}
          size={200}
          color="#000"
          loading
        />
      </div>
    </TransactionLoadingWrapper>
  );
};

export default TransactionLoading;

// import React, { Component } from 'react';
// import styled from 'styled-components';
// import { Helmet, HelmetProvider } from 'react-helmet-async';
// import { BarLoader } from 'react-spinners';

// import AdblockDetector from 'SharedComponents/adblock-detector';

// import styles from  './index.css.js';

// const NotFoundWrapper = styled.div`${styles}`;

// export default class NotFound extends Component {
//   render() {
//     const params = (new URL(document.location)).searchParams;
//     const merchantName = params.get('merchant_name');
//     const retailStoreImageUrl = params.get('retail_store_logo_url');
//     const rate = params.get('rate');


//     return (
//       <NotFoundWrapper>
//         <Helmet>
//           <title>Taking you to {merchantName}</title>
//           <meta name="description" content="Preparing to launch" />
//         </Helmet>
//         <div className="container">
//           <div className="shopping-notification">
//             <AdblockDetector />
//           </div>
//           <img src={retailStoreImageUrl} alt={merchantName}></img>
//           <h1>Taking you to {merchantName}</h1>
//           {/* <p>{merchantName} will {rate}</p> */}
//           <p>Please wait while we take you to {merchantName}</p>
//           <BarLoader
//             sizeUnit={"px"}
//             size={200}
//             color="#000"
//             loading
//           />
//         </div>
//       </NotFoundWrapper>
//     );
//   }
// }

// http://localhost:3000/transaction-loading?retail_store_id=3778,affiliate_network_id=9,merchant_id=41039,date_created=2019-05-24%2012%3A50%3A00,date_modified=2019-05-24%2012%3A50%3A00,merchant_name=eBay,avatar_url=https%3A%2F%2Fupload.wikimedia.org%2Fwikipedia%2Fcommons%2Fthumb%2F1%2F1b%2FEBay_logo.svg%2F300px-EBay_logo.svg.png,custom_logo_directory=merchants_logos%2Flogo-ebay.png,commission_type=%25%20Per%20Sale,commission_rate=6,category=,categories_string=Computers%20Alcohol%20Deals%20%26%20Freebies%20Department%20Store%20Electronics%20Fashion%20Gifts%20%26%20Presents%20Health%20%26%20Beauty%20Home%20%26%20Garden%20Jewellery%20%26%20Watches%20Kids%20Mobile%20Phones%20Music%20Office%20%26%20Business%20Pets%20Sports%20Toys%20Games%2C%20DVDs%20%26%20Videos%20Books%20%26%20Magazines%20Cars%20Baby%20%26%20Parents%20Arts%20%26%20Crafts%20Costume%20New%20Zealand%20School%20Halloween%20Food%20%26%20Drink%20Furniture%20Games%20Gadgets%20Jewellery%20Office%20Outdoors%20Baby%20Books%20Business%20Education%20Electrical%20Kitchen%20Valentine%20,summary=Whatever%20it%20is%2C%20you%20can%20get%20it%20on%20eBay.,target_url=https%3A%2F%2Fwww.ebay.com.au%2F,an_target_url=,status=Active,tracking_url=http%3A%2F%2Frover.ebay.com%2Frover%2F1%2F705-53470-19255-0%2F1%3Fff3%3D4%26pub%3D5575508365%26campid%3D5338543744,tracking_code=null,retail_store_status=1,affiliate_network_uri=,commission_type_id=1,merchant_description=When%20it%27s%20on%20your%20mind%2C%20it%27s%20on%20eBay,clicks=68,shopnate_rate=3,retail_store_web_name=ebay,in_extension=true,in_mobile=1,direct_to_store=true,extension_link=,commission_description=%25%20per%20sale,coupons_count=0,rate=Boost%20Your%20Super%20Up%20To%203.0%25%20per%20sale,retail_store_logo_url=http%3A%2F%2Flocalhost%2Fshopnate%2Fassets%2Fmerchants_logos%2Flogo-ebay.png,image_alt_text=eBay,image_link_url=http%3A%2F%2Flocalhost%2Fshopnate%2Fshop%2Febay,more_info_link_url=http%3A%2F%2Flocalhost%2Fshopnate%2Fshop%2Febay,deals_link_url=http%3A%2F%2Flocalhost%2Fshopnate%2Fshop%2Febay,shop_now_link_url=http%3A%2F%2Flocalhost%2Fshopnate%2Ftransaction%2Febay%2F3778,deals_count=0
